// token所需
import http from '@/http/http'
import urls from '@/http/urls'
// 路由
import Vue from 'vue'
import Router from 'vue-router'
// login
import login from '@/pages/login/login'
import company from '@/pages/company/company'
import register from '@/pages/register/register'
// notFound
import notFound from '@/pages/notFound/notFound'
// main
import main from '@/pages/main/main'
import permission from '@/pages/permission/directive'

// 暂时只分引大路由块
import level1 from './level1'


Vue.use(Router)

export const constantRoutes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/company',
    name: 'company',
    component: company
  },
  {
    path: '/register',
    name: 'register',
    component: register
  },
  {
    path: '/login',
    name: 'login',
    component: login
  },
  {
    path: '/permission',
    name: 'permission',
    component: permission,
    redirect: './permission/level1',
  },
  {
    path: '/main',
    name: 'name',
    component: main,
    redirect: './main/level1',
    children: [
      level1,
    ]
  },
  {
    path: '*',
    component: notFound
  },
]

// 获取token
let name;
function createToken() {
  if (location.hash.lastIndexOf('?') > 0) {
    const query = location.hash.split('?')[1];
    const queryArray = query.split('&');
    queryArray.forEach((item) => {
      if (item.indexOf('name') > -1) {
        name = item.split('=')[1];
      }
    });

    const timestamp = Date.now();
    const md5_sign = jsmd5(`loginName=${name}&timestamp=${timestamp}&secret=123`);
    let loginUrl = `${urls.login}?loginName=${name}&timestamp=${timestamp}&sign=${md5_sign}`;
    return http.post(loginUrl);
  }
}

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = instanceAxios.defaults.headers.token || '';
  // token存在
  if (token) {
    next();
  } else {
    // 不存在请求
    if (location.hash.lastIndexOf('?') > 0) {
      // 刷新 token
      createToken().then((res) => {
        instanceAxios.defaults.headers.token = res.value;
        next();
        localStorage.token = res.value;
      })
    } else {
      instanceAxios.defaults.headers.token = localStorage.token;
      next();
    }
  }
})

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js